/** @format */

import template from './gb-item-table-widget.html';
import './gb-item-table-widget.scss';

import { ceil, floor } from 'lodash';

export const GbItemTableWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbWidget: '^^',
    },
    controller: class GbItemTableWidgetComponent {
        constructor($gbItem, $interval, $ccColors, $element) {
            'ngInject';

            this.$gbItem = $gbItem;
            this.$interval = $interval;
            this.$ccColors = $ccColors;
            this.$element = $element;

            this.page = 1;
            this.styles = {};

            this.defaultItemCardType = 'standard_table';
        }

        getItemCardType() {
            // 'standard_table' || 'compact_table' || 'tall_card'

            return this.gbWidget.widget.card_type || this.defaultItemCardType;
        }

        getCardStyles() {
            this.styles['background-color'] = this.gbWidget.widget.table_background_color;
            this.styles['color'] = this.$ccColors.getContrast(this.styles['background-color']);
            return this.styles;
        }

        getItems() {
            return this.$gbItem.cache.query(
                {
                    auction: this.gbApp.getAuctionUrl(),
                    is_visible: true,
                },
                (item) => {
                    let hiddenItems = this.gbWidget.widget && this.gbWidget.widget.hidden_items;
                    return hiddenItems && hiddenItems.indexOf(item.uuid) === -1;
                }
            );
        }

        getWrapperClass() {
            let transition = this.gbWidget.widget.transition;

            if (transition === 'scroll-left' || transition === 'scroll-right') {
                return 'layout-row';
            }
        }

        getTableStyle() {
            let fullWidth;
            let transition = this.gbWidget.widget.transition;
            let direction = transition === 'scroll-left' || transition === 'scroll-top' ? 'normal' : 'reverse';

            if (this.getColumns() > 1) {
                fullWidth = (this.getItemWidth() * this.getItems().length) / this.getRows();
            } else {
                fullWidth = (this.getItemWidth() * this.getItems().length) / this.getItemsPerPage();
            }

            if (transition === 'scroll-left' || transition === 'scroll-right') {
                let horizontalAnimation = `scrollHorizontal ${
                    (this.gbWidget.widget.slide_interval * this.getItems().length) / this.getItemsPerPage()
                }s linear infinite ${direction}`;
                return {
                    '-webkit-animation': horizontalAnimation,
                    '-moz-animation': horizontalAnimation,
                    animation: horizontalAnimation,
                    minWidth: fullWidth + 'px',
                    width: fullWidth + 'px',
                };
            }

            if (transition === 'scroll-bottom' || transition === 'scroll-top') {
                let animation = `scrollVertical ${
                    (this.gbWidget.widget.slide_interval * this.getItems().length) / this.getItemsPerPage()
                }s linear infinite ${direction}`;
                return {
                    '-webkit-animation': animation,
                    '-moz-animation': animation,
                    animation: animation,
                };
            }
        }

        getItemWidth() {
            let wrapperWidth = this.$element[0].firstChild.clientWidth;
            let itemWidth = wrapperWidth / this.getColumns();

            return itemWidth;
        }

        getItemHeight() {
            let wrapperHeight = this.$element[0].firstChild.clientHeight;
            let itemHeight = (wrapperHeight / this.getItemsPerPage()) * this.getColumns();

            return itemHeight;
        }

        getColumns() {
            return this.gbWidget.widget.columns;
        }

        getRows() {
            return this.gbWidget.widget.rows;
        }

        getItemStyles() {
            let height = floor(this.getItemHeight());
            let width = floor(this.getItemWidth());

            height = height + 'px';
            width = width + 'px';

            return {
                width: width,
                height: height,
                maxHeight: height,
                maxWidth: width,
                minHeight: height,
                minWidth: width,
            };
        }

        getItemsPerPage() {
            return this.getColumns() * this.getRows();
        }

        getFadeInPerPage() {
            if (this.gbWidget.widget.transition === 'fade-in') {
                return this.getItemsPerPage();
            }
        }

        getFirstItem() {
            if (this.gbWidget.widget.transition === 'fade-in') {
                return this.getItemsPerPage() * (this.page - 1);
            }
        }

        goNextPage() {
            if (this.getItemsPerPage() * this.page >= this.getItems().length) {
                // On the last page
                this.page = 1;
            } else {
                this.page++;
            }
        }

        startPageTimer() {
            this.$pageChangeDelay = this.gbWidget.widget.slide_interval * 1000;

            this.$pageTimer = this.$interval(() => {
                this.goNextPage();
            }, this.$pageChangeDelay);
        }

        cancelPageTimer() {
            if (this.$pageTimer) {
                this.$interval.cancel(this.$pageTimer);
            }
        }

        $onInit() {
            if (this.gbWidget.widget.transition === 'fade-in') {
                this.startPageTimer();
            }
        }

        $onDestroy() {
            this.cancelPageTimer();
        }
    },
};
